export const getPodcasts = () => {
    return [
        {
            main: true,
            icon: '/images/podcast/podcast_realcup_gg.webp',
            title: 'podcast.realcup_gg',
            owner: 'podcast.gg',
            link: 'https://open.spotify.com/episode/4ASeGxJzmnDTk01FoQX5a0?si=3T8xl1oQSCy7l3ZEGjcvaQ&nd=1&dlsi=fa1a12c80f2b425a',
        },

        {
            main: false,
            icon: '/images/podcast/fiad_gg.webp',
            title: 'podcast.fiad_rb',
            owner: 'podcast.rb',
            link: 'https://www.youtube.com/watch?v=bUUPOqhv4Mk&ab_channel=ForoFiAD',
        },
        {
            main: false,
            icon: '/images/podcast/fiad_gg.webp',
            title: 'podcast.fiad_gg_future',
            owner: 'podcast.gg',
            link: 'https://www.youtube.com/watch?v=PM8NkAnJnVw&t=175s&ab_channel=ForoFiAD',
        },
        {
            main: false,
            icon: '/images/podcast/fiad_gg.webp',
            title: 'podcast.fiad_gg_meli',
            owner: 'podcast.gg',
            link: 'https://www.youtube.com/watch?v=zhX0Iz9RRpY&ab_channel=ForoFiAD',
        },
        {
            main: false,
            icon: '/images/podcast/fiad_gg.webp',
            title: 'podcast.fiad_gg',
            owner: 'podcast.gg',
            link: 'https://www.youtube.com/watch?v=cMGxHfkAd0Y&ab_channel=ForoFiAD',
        },
        {
            main: false,
            icon: '/images/podcast/edup_ld.webp',
            title: 'podcast.edup_ld',
            owner: 'podcast.ld',
            link: 'https://open.spotify.com/episode/65G6r35FPmuTJKZ4vnwpbg',
        },
        {
            main: false,
            icon: '/images/podcast/blockchain_rb.webp',
            title: 'podcast.blockchain_rb',
            owner: 'podcast.rb',
            link: 'https://www.youtube.com/watch?v=McedPcvQmfI&ab_channel=Fundaci%C3%B3nBlockchainArgentina',
        },
        {
            main: false,
            icon: '/images/podcast/change_gg.webp',
            title: 'podcast.change_gg',
            owner: 'podcast.gg',
            link: 'https://drive.google.com/file/d/1_E7h0vieg49rPGrr6up2h4p1epF9Dzyo/view',
        },
        {
            main: false,
            icon: '/images/podcast/badge_summit_tm.webp',
            title: 'podcast.badge_summit_tm',
            owner: 'podcast.tm',
            link: 'https://www.youtube.com/watch?v=e2YjG6Dh8-8&t=2s&ab_channel=BadgeSummit',
        },
    ];
};

import { POK_AUTHOR, POK_PUBLISHER, POK_URL } from './pokJsonLd.js';

export function buildFaqPageJsonLd(faq) {
    return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faq.map(({ q, a }) => ({
            '@type': 'Question',
            name: q,
            // author on acceptedAnswer gives answer engines (especially Google
            // SGE) an explicit answerer attribution they can surface in cards.
            acceptedAnswer: { '@type': 'Answer', text: a, author: POK_AUTHOR },
        })),
    };
}

export function buildBlogPostingJsonLd(post, lang) {
    const url = post.link?.startsWith('http') ? post.link : `${POK_URL}${post.link}`;
    return {
        '@type': 'BlogPosting',
        headline: post.title,
        description: post.description,
        image: `${POK_URL}${post.image}`,
        datePublished: post.date,
        // Freshness signal for answer engines: dateModified is git-derived per
        // post (see scripts/generate-blog-dates-modified.mjs). Falls back to
        // datePublished when the lookup is unavailable.
        dateModified: post.dateModified ?? post.date,
        inLanguage: lang,
        mainEntityOfPage: url,
        url,
        author: POK_AUTHOR,
        publisher: POK_PUBLISHER,
    };
}

const LATEST_POSTS_LABEL = {
    en: 'Latest Blog Posts',
    es: 'Últimas publicaciones del blog',
    pt: 'Últimas publicações do blog',
};

export function generateBlogJsonLd(locale, articles) {
    const blogUrl = locale === 'en' ? `${POK_URL}/blog` : `${POK_URL}/blog/${locale}`;
    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: LATEST_POSTS_LABEL[locale] ?? LATEST_POSTS_LABEL.en,
        url: blogUrl,
        itemListElement: articles.map((post, i) => ({
            '@type': 'ListItem',
            position: i + 1,
            url: post.link?.startsWith('http') ? post.link : `${POK_URL}${post.link}`,
            name: post.title,
        })),
    };
}
